export default __webpack_public_path__ + "static/media/result_background.69abc6ed.png";